module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><g><polygon class=\"st0\" points=\"15,15.2 5,15.2 5,5.2 11.1,5.2 13.1,3.2 3,3.2 3,17.2 17,17.2 17,9.2 15,11.2 \"></polygon><polygon class=\"st0\" points=\"7.9,7 5.8,9.1 10,13.3 10,13.3 10,13.3 19,4.3 16.9,2.2 10,9.1 \"></polygon></g></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/preferences.svg
 ** module id = 1055
 ** module chunks = 0
 **/